function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = () => ([]);
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = "../../../../../../../../../var/lib/nave/installed/20.12.1/lib/node_modules/prop-types sync recursive";
module.exports = webpackEmptyContext;